"use client";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { usePathname } from "next/navigation";
import { useState } from "react";
import ActiveAnchor from "@/components/common/ActiveAnchor";
import List from "@/components/common/List";
import type { SingleLineMenu as SingleLineMenuType } from "../../../types";
import { isGroupNavItem } from "../../../utils";
import { getMenuActiveItemIndex } from "../../../utils/getMenuActiveItemIndex";
import { getPageNavBarItems } from "../../../utils/getPageNavBarItems";
import s from "./SingleLineMenu.module.scss";

export interface SingleLineMenuProps {
  menuItems: SingleLineMenuType;
}

export default function SingleLineMenu({ menuItems }: SingleLineMenuProps) {
  const pathname = usePathname();
  const initialIndex = getMenuActiveItemIndex(pathname, menuItems);
  const [openIndex, setOpenIndex] = useState(initialIndex);

  const handleOpen = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <List
      items={menuItems}
      renderItem={(item, index) =>
        isGroupNavItem(item) ? (
          <div className={s.anchor}>
            <span onClick={() => handleOpen(index)} className={s.label}>
              {item.label}
              {openIndex === index ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </span>
            {openIndex === index && (
              <div className={s.subMenu}>
                <List
                  items={getPageNavBarItems(item.subMenuItems)}
                  renderItem={(item) => (
                    <ActiveAnchor
                      href={item.url}
                      openInNewTab={item.openInNewTab}
                      className={s.subAnchor}
                    >
                      {item.label}
                    </ActiveAnchor>
                  )}
                  variant="vertical"
                />
              </div>
            )}
          </div>
        ) : (
          <ActiveAnchor
            href={item.url}
            openInNewTab={item.openInNewTab}
            className={s.anchor}
          >
            {item.label}
          </ActiveAnchor>
        )
      }
      variant="vertical"
      className={s.list}
    />
  );
}
